import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIsMobile } from './useIsMobile';
import VeniarNav from './VeniarNav';
import VeniarFooter from './VeniarFooter';

const LAGOON = 'var(--rosso)';
const ORANGE = 'var(--rosso)';

export default function MissionPage() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const heroBg = '#0E0D0C';

  useEffect(() => {
    document.title = 'Mission — RewardsNow';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--vn-bg, var(--rn-bg))',
        fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif",
      }}
    >
      <VeniarNav />

      <main>
        {/* ── Hero ─────────────────────────────────────────────────────── */}
        <section
          style={{
            background: heroBg,
            maxWidth: '100%',
            paddingTop: isMobile ? 120 : 160,
            paddingBottom: isMobile ? 72 : 100,
          }}
        >
          <div style={{ maxWidth: '720px', padding: isMobile ? '0 24px' : '0 8%' }}>
          {/* Gold eyebrow */}
          <p style={s.eyebrow}>COMPANY</p>

          {/* H1 */}
          <h1
            style={{
              ...s.h1,
              fontSize: isMobile ? '2.8rem' : '4.8rem',
              color: '#FFF8EA',
            }}
          >
            What is RewardsNow?
          </h1>

          {/* Gold accent bar */}
          <div style={{ ...s.goldBar, background: 'rgba(255,248,234,0.30)' }} />

          {/* Body */}
          <p style={{ ...s.body, color: 'rgba(255,248,234,0.68)' }}>
            RewardsNow is a company that runs a software where rewards points are
            standardized among a large group of different companies. For example,
            someone could use RewardsNow points to get discounts at Nordstrom or at
            Dunkin — all from the same app.
          </p>
          <p style={{ ...s.body, color: 'rgba(255,248,234,0.68)', marginTop: '20px' }}>
            RewardsNow is also willing to, for a bigger contract, become a
            long-term partner of a company in order to set up their own rewards
            system without needing to run their own software operations.
          </p>
          <p style={{ ...s.body, color: 'rgba(255,248,234,0.68)', marginTop: '20px' }}>
            RewardsNow seeks to bring convenience to both the customer and the
            companies they interact with. Customers are given a map of RewardsNow
            partners near them, alongside the ability to scroll a list of
            RewardsNow partners, where companies can pay RewardsNow a larger sum
            of money to be recommended to users more often.
          </p>
          </div>
        </section>

        {/* ── CTA section ──────────────────────────────────────────────── */}
        <section
          style={{
            background: 'var(--vn-panel, #F7E8CF)',
            padding: isMobile ? '48px 0 80px' : '64px 0 100px',
          }}
        >
          <div
            style={{
              maxWidth: '720px',
              padding: isMobile ? '0 24px' : '0 8%',
            }}
          >
            <p style={{ ...s.body, marginBottom: '20px' }}>
              Any questions,{' '}
              <button style={s.inlineLink} onClick={() => navigate('/support')}>
                contact support
              </button>
              .
            </p>
            <button
              style={s.btnPrimary}
              onClick={() => navigate('/support')}
            >
              Contact support
            </button>
          </div>
        </section>
      </main>

      <VeniarFooter />
    </div>
  );
}

const s = {
  eyebrow: {
    color: 'var(--vn-text)',
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.24em',
    textTransform: 'uppercase',
    margin: '0 0 20px',
  },
  h1: {
    color: 'var(--vn-text, var(--rn-text))',
    fontWeight: '900',
    lineHeight: 1.06,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    fontFamily: "'Archivo','Inter',sans-serif",
    margin: '0 0 24px',
  },
  goldBar: {
    width: '48px',
    height: '1px',
    background: 'var(--vn-line, var(--vn-card-border))',
    borderRadius: 0,
    marginBottom: '28px',
  },
  body: {
    color: 'var(--vn-text-sub, var(--rn-text-sub))',
    fontSize: '17px',
    lineHeight: 1.75,
    margin: 0,
  },
  btnPrimary: {
    padding: '14px 30px',
    background: ORANGE,
    border: 'none',
    color: '#FFFFFF',
    borderRadius: 0,
    fontSize: '15px',
    fontWeight: '700',
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
  inlineLink: {
    background: 'none',
    border: 'none',
    padding: 0,
    color: LAGOON,
    fontSize: '17px',
    fontWeight: '600',
    cursor: 'pointer',
    fontFamily: 'inherit',
    textDecoration: 'underline',
  },
};
